import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
    forwardRef,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

const FIELD_VALUE_ACESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputSearchComponent),
    multi: true,
};

@Component({
    selector: "app-input-search",
    standalone: false,
    templateUrl: "./input-search.component.html",
    providers: [FIELD_VALUE_ACESSOR],
})
export class InputSearchComponent implements ControlValueAccessor {
    @Input() placeholder = "Filtrar";
    @Input() disabled = false;
    @Input() loading = false;
    @Input() fullWidth = false;
    @Input() value = "";
    @Input() label = "";

    @Output() search = new EventEmitter<string>();
    @Output() valueChange = new EventEmitter<string>();
    @Output() valorSelecionado = new EventEmitter<any>();

    onChange: (_: any) => void = () => {};
    onTouched: (_: any) => void = () => {};

    @ViewChild("inputRef") inputRef!: ElementRef;

    inputValue: any;

    onKeyPress(event: KeyboardEvent) {
        if (event.key === "Enter") {
            this.emitSearch();
        }
    }

    onInput(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.value = value;
        this.onChange(value);
        this.valueChange.emit(value);
    }

    emitSearch() {
        if (!this.disabled && !this.loading) {
            this.search.emit(this.value);
        }
    }

    clear() {
        this.value = "";
        this.onChange("");
        this.valueChange.emit("");
        this.inputRef.nativeElement.focus();
    }

    writeValue(v: any): void {
        this.value = v ?? '';
    }

    valorPesquisado(event: string) {
        // event = event.payload ? event.payload : event;
        this.value = event;
        this.inputValue = event;
        // this.updateInputValueCheck();
        // this.valorParcialParaPesquisar = undefined;
        this.valorSelecionado.emit(event);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    get nativeElement() {
        return this.inputRef?.nativeElement;
    }
}
